export const VISIT_SEARCH_REQUEST = '[VISIT] VISIT_SEARCH_REQUEST';
export const VISIT_SEARCH_SUCCESS = '[VISIT] VISIT_SEARCH_SUCCESS';
export const VISIT_SEARCH_FAILED = '[VISIT] VISIT_SEARCH_FAILED';

export const VISIT_CHECK_OUT_REQUEST = '[VISIT] VISIT_CHECK_OUT_REQUEST';
export const VISIT_CHECK_OUT_SUCCESS = '[VISIT] VISIT_CHECK_OUT_SUCCESS';
export const VISIT_CHECK_OUT_FAILED = '[VISIT] VISIT_CHECK_OUT_FAILED';

export const VISIT_CHECK_IN_REQUEST = '[VISIT] VISIT_CHECK_IN_REQUEST';
export const VISIT_CHECK_IN_SUCCESS = '[VISIT] VISIT_CHECK_IN_SUCCESS';
export const VISIT_CHECK_IN_FAILED = '[VISIT] VISIT_CHECK_IN_FAILED';

export const CREATE_VISIT_REQUEST = '[VISIT] CREATE_VISIT_REQUEST';
export const CREATE_VISIT_SUCCESS = '[VISIT] CREATE_VISIT_SUCCESS';
export const CREATE_VISIT_FAILED = '[VISIT] CREATE_VISIT_FAILED';

export const VISITOR_LAST_VISITS_REQUEST = '[VISIT] VISITOR_LAST_VISITS_REQUEST';
export const VISITOR_LAST_VISITS_SUCCESS = '[VISIT] VISITOR_LAST_VISITS_SUCCESS';
export const VISITOR_LAST_VISITS_FAILED = '[VISIT] VISITOR_LAST_VISITS_FAILED';

export const RESET_VISITS_RESULTS = '[VISITS] RESET_VISITS_RESULTS';
export const RESET_VISIT_FORM = '[VISIT] RESET_VISIT_FORM';
